'use client';

import ResponsiveImage from '@/components/ui/ResponsiveImage';
import { useLanguage } from '@/lib/i18n/LanguageContext';

interface Partner {
  id: string;
  name: string;
  logo_url: string | null;
  additional_info: string | null;
}

interface EventPartnersDisplayProps {
  partners: Partner[];
}

export default function EventPartnersDisplay({ partners }: EventPartnersDisplayProps) {
  const { t } = useLanguage();

  if (!partners || partners.length === 0) {
    return null; // Hide section entirely if no partners
  }

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('event.tabs.partners') || 'Partners'}</h2>

      {/* Partner Grid - 2 columns on desktop, 1 on mobile */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {partners.map((partner) => (
          <div
            key={partner.id}
            className="flex flex-col items-center text-center"
          >
            {/* Logo - 128px */}
            <div className="mb-4">
              <ResponsiveImage
                src={partner.logo_url}
                alt={partner.name}
                variant="partner"
                size="3xl"
                bgColor="bg-transparent"
              />
            </div>

            {/* Partner Name */}
            <h3 className="text-lg font-semibold text-gray-900 mb-1">
              {partner.name}
            </h3>

            {/* Additional Info */}
            {partner.additional_info?.trim() && (
              <p className="text-sm font-normal text-gray-600">
                {partner.additional_info}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
